function Hero({ game, onTrailerClick, onPrimaryClick }) {
  return (
    <section id="hero" className="hero" aria-label="Hero">
      <div className="container hero-grid">
        <div className="hero-content reveal reveal-visible">
          <h1>{game.name}</h1>
          <h2>{game.tagline}</h2>
          <p className="hero-description">{game.description}</p>

          <ul className="hero-bullets" aria-label="Game highlights">
            {game.highlights.map((highlight) => (
              <li key={highlight}>{highlight}</li>
            ))}
          </ul>

          {!!game.storeLinks?.length && (
            <div className="hero-store-wrap">
              <p className="hero-store-title">PLAY THERE:</p>
              <div className="hero-store-links" aria-label="Game platforms">
                {game.storeLinks.map((store) => (
                  <a
                    key={store.name}
                    href={store.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary btn-primary-lg store-link"
                    style={{ '--store-color': store.color }}
                    aria-label={`Open ${store.name}`}
                  >
                    <span className="store-icon" aria-hidden="true">
                      {store.iconSrc ? <img src={store.iconSrc} alt="" /> : store.icon}
                    </span>
                    <span>{store.name}</span>
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="hero-media reveal reveal-visible" aria-hidden="true">
          {game.heroImageSrc ? (
            <img className="hero-image" src={game.heroImageSrc} alt="" />
          ) : (
            <div className="media-placeholder large" />
          )}
        </div>
      </div>
    </section>
  );
}

export default Hero;
